import { render } from "./ColumnWithData.vue?vue&type=template&id=984e939c"
import script from "./ColumnWithData.vue?vue&type=script&lang=js"
export * from "./ColumnWithData.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__